import { useMemo } from 'react';

import { useGetTravelReceiptsStatus } from '@work4all/components/lib/components/entity-preview/travel-receipts-preview/use-get-travel-receipts-status';

import { AppParts, useCanView, useUser } from '@work4all/data';

import { TravelReceipts } from '@work4all/models/lib/Classes/TravelReceipts.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { AttachmentCell } from './AttachmentCell';
import { TravelStatusCell } from './cell-renderer/TravelStatusCell';
import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/travelReceipts-table-schema.json';

const forceRequestFields: TravelReceipts = {
  travelExpenses: {
    closedByuserid: null,
    insertionREDate: null,
  },
};

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

export function TravelReceiptsTable(props: IEntityTableV8) {
  const getTravelReceiptsStatus = useGetTravelReceiptsStatus();
  const prefilter = useOwnTravelReceipt();

  const dataTable = useEntityDataTableV8<TravelReceipts, never>({
    ...props,
    prefilter,
    schema: schema as never,
    defaultSort,
    forceRequestFields,
    cells: {
      Attachment: AttachmentCell,
      TravelStatusCell,
    },
    rowModifiers: (value) => {
      const { key: status } = getTravelReceiptsStatus(value.travelExpenses);

      return {
        isFaded: status === 'booked',
        isShade1: status === 'closed' || status === 'booked',
      };
    },
  });

  return <EntityTableV8 {...props} {...dataTable} />;
}

export const useOwnTravelReceipt = () => {
  const user = useUser();
  const prefilter = useMemo(() => {
    return {
      'travelExpenses.businessPartner.data.id': {
        $eq: user.supplierCode,
      },
    };
  }, [user.supplierCode]);

  const canViewTravelReceipts = useCanView(AppParts.TRAVEL_RECEIPTS);
  const isFullUser = useCanView(AppParts.FULL);

  return canViewTravelReceipts && !isFullUser ? [prefilter] : [];
};
